import styled from 'styled-components';

const HighlightedTextSectionStyle = styled.section`
	--infoWrapPadding: var(--sp13x) var(--sp14x) var(--sp13x) 0;
	--galleryWrapWidth: 45%;
	--infoNumberMarginBottom: var(--sp7x);
	--infoTitleMarginBottom: var(--sp7x);
	--infoDescriptionMarginBottom: var(--sp7x);
	--infoTipMarginRight: var(--sp2x);
	--imageProportion: 82.7%;

	--learnMoreMarginTop: var(--sp5x);

	--imageBorderRadius: var(--sp6x);

	.section {
		margin-bottom: calc(var(--contMarginV) / 2) !important;
	}

	.highlight-wrapper {
		display: flex;
	}

	.info-wrap {
		width: calc(100% - var(--galleryWrapWidth));
		padding: var(--infoWrapPadding);

		.info-content {
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.info-number {
				margin-bottom: var(--infoNumberMarginBottom);
			}

			.info-title {
				margin-bottom: var(--infoTitleMarginBottom);
			}

			.info-description {
				margin-bottom: var(--infoDescriptionMarginBottom);
			}

			.learn-more {
				display: block;
				width: fit-content;
				margin-top: var(--learnMoreMarginTop);
				text-underline-offset: var(--sp0-5x);

				&.has-space {
					margin-left: calc(var(--h4) + var(--infoTipMarginRight));
				}
			}

			.tip-wrap {
				display: flex;

				.info-tip-icon {
					margin-right: var(--infoTipMarginRight);
				}
			}
		}
	}

	.gallery-wrap {
		width: var(--galleryWrapWidth);

		.imageCont {
			--imagePaddingTop: var(--imageProportion);

			img {
				object-fit: cover;
				border-radius: var(--imageBorderRadius);
				overflow: hidden;
			}
		}
	}

	/* //! 1920 */
	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--infoWrapPadding: var(--sp10x) var(--sp11x) var(--sp10x) 0;
		--infoNumberMarginBottom: var(--sp5x);
		--infoTitleMarginBottom: var(--sp5x);
		--infoDescriptionMarginBottom: var(--sp5x);
		--infoTipMarginRight: var(--sp2x);

		--learnMoreMarginTop: var(--sp3x);

		--imageBorderRadius: var(--sp5x);
	}

	/* //! 1510 */
	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--infoWrapPadding: var(--sp7x) var(--sp8x) var(--sp7x) 0;
		--infoNumberMarginBottom: var(--sp4x);
		--infoTitleMarginBottom: var(--sp4x);
		--infoDescriptionMarginBottom: var(--sp4x);
		--infoTipMarginRight: var(--sp1-5x);

		--learnMoreMarginTop: var(--sp3x);

		--imageBorderRadius: var(--sp4x);
	}

	/* //! 1440 */
	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--infoWrapPadding: var(--sp7x) var(--sp8x) var(--sp7x) 0;
		--infoNumberMarginBottom: var(--sp4x);
		--infoTitleMarginBottom: var(--sp4x);
		--infoDescriptionMarginBottom: var(--sp4x);
		--infoTipMarginRight: var(--sp1-5x);

		--learnMoreMarginTop: var(--sp3x);
		--imageBorderRadius: var(--sp4x);
	}

	/* //! 1280 */
	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--infoWrapPadding: var(--sp6x) var(--sp5x) var(--sp6x) 0;
		--infoNumberMarginBottom: var(--sp4x);
		--infoTitleMarginBottom: var(--sp4x);
		--infoDescriptionMarginBottom: var(--sp4x);
		--infoTipMarginRight: var(--sp1-5x);

		--learnMoreMarginTop: var(--sp2x);
		--imageBorderRadius: var(--sp3x);
	}

	/* //! 1024 */
	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--infoWrapPadding: var(--sp6x) var(--sp8x) var(--sp6x) 0;
		--infoNumberMarginBottom: var(--sp3x);
		--infoTitleMarginBottom: var(--sp3x);
		--infoDescriptionMarginBottom: var(--sp3x);
		--infoTipMarginRight: var(--sp1x);

		--galleryWrapWidth: 100%;
		--imageProportion: 67%;
		--learnMoreMarginTop: var(--sp2x);

		--imageBorderRadius: var(--sp3x);

		.highlight-wrapper {
			flex-direction: column;
		}

		.info-wrap {
			width: 100%;
		}
	}

	/* //! 768 */
	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--infoWrapPadding: var(--sp5x) var(--sp8x) var(--sp5x) 0;
		--infoNumberMarginBottom: var(--sp3x);
		--infoTitleMarginBottom: var(--sp3x);
		--infoDescriptionMarginBottom: var(--sp3x);
		--infoTipMarginRight: var(--sp1x);

		--imageBorderRadius: var(--sp3x);

		--galleryWrapWidth: 100%;
		--imageProportion: 67%;
		--learnMoreMarginTop: var(--sp2x);

		.highlight-wrapper {
			flex-direction: column;
		}

		.info-wrap {
			width: 100%;
		}
	}

	/* //! Mobile */
	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--infoWrapPadding: var(--sp4x) var(--sp3x) var(--sp4x) 0;
		--infoNumberMarginBottom: var(--sp3x);
		--infoTitleMarginBottom: var(--sp3x);
		--infoDescriptionMarginBottom: var(--sp3x);
		--infoTipMarginRight: var(--sp1x);

		--galleryWrapWidth: 100%;
		--imageProportion: 86.7%;
		--learnMoreMarginTop: var(--sp2x);

		--imageBorderRadius: var(--sp2x);

		.highlight-wrapper {
			flex-direction: column;
		}

		.info-wrap {
			width: 100%;
		}
	}
`;

export default HighlightedTextSectionStyle;
